<div class="text" [class.underline]="decoration === 'underline'">
  <ng-content></ng-content>
</div>
@if (icon) {
  <tbx-icon class="icon" [name]="icon"></tbx-icon>
}
